// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-accordionmenu_default__1ipod"};